import { restrictions } from 'state/features-list/constants';

import { createFlowRoutes } from './create-flow-routes';
import { WpoAppointmentsRoutes } from './state/constants';
import { shouldGrantAccessToWpoAppointmentsFlow } from './state/helpers';

const wpoAppointmentsModule = createFlowRoutes({
  urlPrefix: '/wpo-appointments',
  routeNames: WpoAppointmentsRoutes,
  shouldGrantAccess: shouldGrantAccessToWpoAppointmentsFlow,
  restrictions: [restrictions['wpo_online_scheduling']],
  introTitleKey: 'appointments.appointment_intro.title',
});

export default wpoAppointmentsModule;
